module.exports = __webpack_public_path__ + "5bec532f729ec6645852a1a4caff361a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/audioDescription.svg
// module id = Gxgu
// module chunks = 0